import { Component, inject, Input, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { P0003605DetectionFinBidonModalComponent } from '../../../P0003605/Modal/p0003605-detection-fin-bidon-modal/p0003605-detection-fin-bidon-modal.component';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { LabelConfigurationComponent } from '../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { SwitchConfigurationComponent } from '../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P0003607DureeInversion } from '../../../P0003607/Enum/P0003607DureeInversion';
import {
  P00080ConsignRXBas,
  P00080ConsignRXHaut,
} from '../../Enum/P00080Consigne';

@Component({
  selector: 'app-p00080-installation-alarm-rx',
  templateUrl: './p00080-installation-alarm-rx.component.html',
  styleUrls: ['./p00080-installation-alarm-rx.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    SwitchConfigurationComponent,
    TranslatePipe,
  ],
})
export class P00080InstallationAlarmRXComponent implements OnInit {
  private modalController: ModalController = inject(ModalController);
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P00080ConsignRXBas = P00080ConsignRXBas;
  protected readonly P00080ConsignRXHaut = P00080ConsignRXHaut;
}
